import moment from 'moment/moment';
import { localeFromDomain } from 'frontend-resources/js/Helpers/Locales';

export default function ({ app }) {
    moment.locale(localeFromDomain().replace('_', '-'));

    app.moment = moment;
}
